class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce(event => {
			this.onSubmitHandler(event);
		}, 800);

		const facetForm = this.querySelector("form");
		facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
	}

	static setListeners() {
		const onHistoryChange = event => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach(element => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		const loadingSpinners = document.querySelectorAll(
			".facets-container .loading__spinner, facet-filters-form .loading__spinner"
		);
		loadingSpinners.forEach(spinner => spinner.classList.remove("hidden"));
		document
			.getElementById("ProductGridContainer")
			.querySelector(".collection")
			.classList.add("loading");
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		sections.forEach(section => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = element => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then(response => response.text())
			.then(responseText => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url }
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
				if (typeof initializeScrollAnimationTrigger === "function")
					initializeScrollAnimationTrigger(html.innerHTML);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
		if (typeof initializeScrollAnimationTrigger === "function")
			initializeScrollAnimationTrigger(html.innerHTML);
	}

	static renderProductGridContainer(html) {
		document.getElementById("ProductGridContainer").innerHTML =
			new DOMParser()
				.parseFromString(html, "text/html")
				.getElementById("ProductGridContainer").innerHTML;

		document
			.getElementById("ProductGridContainer")
			.querySelectorAll(".scroll-trigger")
			.forEach(element => {
				element.classList.add("scroll-trigger--cancel");
			});
	}

	static renderProductCount(html) {
		const count = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductCount").innerHTML;
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");
		container.innerHTML = count;
		container.classList.remove("loading");
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");
		}
		const loadingSpinners = document.querySelectorAll(
			".facets-container .loading__spinner, facet-filters-form .loading__spinner"
		);
		loadingSpinners.forEach(spinner => spinner.classList.add("hidden"));
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");
		const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const facetDetailsElementsFromDom = document.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);

		// Remove facets that are no longer returned from the server
		Array.from(facetDetailsElementsFromDom).forEach(currentElement => {
			if (
				!Array.from(facetDetailsElementsFromFetch).some(
					({ id }) => currentElement.id === id
				)
			) {
				currentElement.remove();
			}
		});

		const matchesId = element => {
			const jsFilter = event
				? event.target.closest(".js-filter")
				: undefined;
			return jsFilter ? element.id === jsFilter.id : false;
		};

		const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
			element => !matchesId(element)
		);
		const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
			matchesId
		);

		facetsToRender.forEach((elementToRender, index) => {
			const currentElement = document.getElementById(elementToRender.id);
			// Element already rendered in the DOM so just update the innerHTML
			if (currentElement) {
				document.getElementById(elementToRender.id).innerHTML =
					elementToRender.innerHTML;
			} else {
				if (index > 0) {
					const {
						className: previousElementClassName,
						id: previousElementId
					} = facetsToRender[index - 1];
					// Same facet type (eg horizontal/vertical or drawer/mobile)
					if (
						elementToRender.className === previousElementClassName
					) {
						document
							.getElementById(previousElementId)
							.after(elementToRender);
						return;
					}
				}

				if (elementToRender.parentElement) {
					document
						.querySelector(
							`#${elementToRender.parentElement.id} .js-filter`
						)
						.before(elementToRender);
				}
			}
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender) {
			const closestJSFilterID = event.target.closest(".js-filter").id;

			if (closestJSFilterID) {
				FacetFiltersForm.renderCounts(
					countsToRender,
					event.target.closest(".js-filter")
				);
				FacetFiltersForm.renderMobileCounts(
					countsToRender,
					document.getElementById(closestJSFilterID)
				);

				const newFacetDetailsElement =
					document.getElementById(closestJSFilterID);
				const newElementSelector =
					newFacetDetailsElement.classList.contains(
						"mobile-facets__details"
					)
						? `.mobile-facets__close-button`
						: `.facets__summary`;
				const newElementToActivate =
					newFacetDetailsElement.querySelector(newElementSelector);

				const isTextInput =
					event.target.getAttribute("type") === "text";

				if (newElementToActivate && !isTextInput)
					newElementToActivate.focus();
			}
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop"
		];

		activeFacetElementSelectors.forEach(selector => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting"
		];

		mobileElementSelectors.forEach(selector => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});

		document
			.getElementById("FacetFiltersFormMobile")
			.closest("menu-drawer")
			.bindEvents();
	}

	static renderCounts(source, target) {
		const targetSummary = target.querySelector(".facets__summary");
		const sourceSummary = source.querySelector(".facets__summary");

		if (sourceSummary && targetSummary) {
			targetSummary.outerHTML = sourceSummary.outerHTML;
		}

		const targetHeaderElement = target.querySelector(".facets__header");
		const sourceHeaderElement = source.querySelector(".facets__header");

		if (sourceHeaderElement && targetHeaderElement) {
			targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
		}

		const targetWrapElement = target.querySelector(".facets-wrap");
		const sourceWrapElement = source.querySelector(".facets-wrap");

		if (sourceWrapElement && targetWrapElement) {
			const isShowingMore = Boolean(
				target.querySelector("show-more-button .label-show-more.hidden")
			);
			if (isShowingMore) {
				sourceWrapElement
					.querySelectorAll(".facets__item.hidden")
					.forEach(hiddenItem =>
						hiddenItem.classList.replace("hidden", "show-more-item")
					);
			}

			targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
		}
	}

	static renderMobileCounts(source, target) {
		const targetFacetsList = target.querySelector(".mobile-facets__list");
		const sourceFacetsList = source.querySelector(".mobile-facets__list");

		if (sourceFacetsList && targetFacetsList) {
			targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			"",
			`${window.location.pathname}${searchParams && "?".concat(searchParams)}`
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id
			}
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll(
			"facet-filters-form form"
		);
		if (event.srcElement.className == "mobile-facets__checkbox") {
			const searchParams = this.createSearchParams(
				event.target.closest("form")
			);
			this.onSubmitForm(searchParams, event);
		} else {
			const forms = [];
			const isMobile =
				event.target.closest("form").id === "FacetFiltersFormMobile";

			sortFilterForms.forEach(form => {
				if (!isMobile) {
					if (
						form.id === "FacetSortForm" ||
						form.id === "FacetFiltersForm" ||
						form.id === "FacetSortDrawerForm"
					) {
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === "FacetFiltersFormMobile") {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join("&"), event);
		}
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
					);
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll("input").forEach(element => {
			element.addEventListener("change", this.onRangeChange.bind(this));
			element.addEventListener("keydown", this.onKeyDown.bind(this));
		});
		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	onKeyDown(event) {
		if (event.metaKey) return;

		const pattern =
			/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
		if (!event.key.match(pattern)) event.preventDefault();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
		if (minInput.value === "") maxInput.setAttribute("data-min", 0);
		if (maxInput.value === "")
			minInput.setAttribute(
				"data-max",
				maxInput.getAttribute("data-max")
			);
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute("data-min"));
		const max = Number(input.getAttribute("data-max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector("a");
		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", event => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		form.onActiveFilterClick(event);
	}
}

customElements.define("facet-remove", FacetRemove);

// ===== Color Swatch Select with Choices.js =====
let colorChoicesInstances = [];

document.addEventListener("DOMContentLoaded", function () {
	loadChoicesJS().then(() => {
		initColorSwatchSelects();
	});
});

// Cargar Choices.js dinámicamente si no está disponible
function loadChoicesJS() {
	return new Promise((resolve, reject) => {
		if (typeof Choices !== "undefined") {
			resolve();
			return;
		}
	});
}

function initColorSwatchSelects() {
	if (typeof Choices === "undefined") {
		console.warn("Choices.js no está cargado");
		return;
	}

	const colorSelects = document.querySelectorAll(
		'select[id^="Filter-"][name*="color"]:not(.choices__input), select[id^="Filter-"][name*="Color"]:not(.choices__input)'
	);

	colorSelects.forEach(select => {
		initChoicesForColorSelect(select);
	});
}

function initChoicesForColorSelect(selectElement) {
	// Evitar inicializar dos veces
	if (
		selectElement.classList.contains("choices__input") ||
		selectElement.hasAttribute("data-choice")
	) {
		return;
	}

	const choicesInstance = new Choices(selectElement, {
		searchEnabled: false,
		itemSelectText: "",
		shouldSort: false,
		callbackOnCreateTemplates: function (template) {
			return {
				item: ({ classNames }, data) => {
					return template(`
            <div class="${classNames.item} ${
				data.highlighted
					? classNames.highlightedState
					: classNames.itemSelectable
			} ${
				data.placeholder ? classNames.placeholder : ""
			}" data-item data-id="${data.id}" data-value="${data.value}" ${
				data.active ? 'aria-selected="true"' : ""
			} ${data.disabled ? 'aria-disabled="true"' : ""}>
              ${getSwatchHTML(data)}
              <span>${data.label}</span>
            </div>
          `);
				},
				choice: ({ classNames }, data) => {
					return template(`
            <div class="${classNames.item} ${classNames.itemChoice} ${
				data.disabled
					? classNames.itemDisabled
					: classNames.itemSelectable
			}" data-select-text="${this.config.itemSelectText}" data-choice ${
				data.disabled
					? 'data-choice-disabled aria-disabled="true"'
					: "data-choice-selectable"
			} data-id="${data.id}" data-value="${data.value}" ${
				data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
			}>
              ${getSwatchHTML(data)}
              <span style="margin-left: 10px;">${data.label}</span>
            </div>
          `);
				}
			};
		}
	});

	// Guardar instancia para destruir después si es necesario
	colorChoicesInstances.push({
		element: selectElement,
		instance: choicesInstance
	});

	// Listener para cambios
	selectElement.addEventListener("change", function (event) {
		// Auto-submit del formulario
		const form = this.closest("form");
		if (form) {
			form.dispatchEvent(
				new Event("submit", { cancelable: true, bubbles: true })
			);
		}
	});
}

function getSwatchHTML(data) {
	// Si no tiene valor o es la opción por defecto, no mostrar swatch
	if (!data.value || data.value === "") {
		return "";
	}

	const swatchColor = data.customProperties?.swatchColor || "";
	const swatchImage = data.customProperties?.swatchImage || "";

	let swatchStyle = `
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #e5e5e5;
    margin-right: 8px;
    vertical-align: middle;
  `;

	if (swatchImage) {
		swatchStyle += `
      background-image: url(${swatchImage});
      background-size: cover;
      background-position: center;
    `;
	} else if (swatchColor) {
		swatchStyle += `background-color: ${swatchColor};`;
	} else {
		swatchStyle += `background-color: #f5f5f5;`;
	}

	return `<span class="color-swatch" style="${swatchStyle}"></span>`;
}

// Re-inicializar después de actualizaciones AJAX de filtros
if (typeof MutationObserver !== "undefined") {
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.addedNodes.length) {
				// Destruir instancias antiguas
				colorChoicesInstances.forEach(({ instance }) => {
					if (instance && typeof instance.destroy === "function") {
						try {
							instance.destroy();
						} catch (e) {
							// Ignorar errores de destrucción
						}
					}
				});
				colorChoicesInstances = [];

				// Re-inicializar
				setTimeout(() => {
					initColorSwatchSelects();
				}, 100);
			}
		});
	});

	const facetsContainer = document.querySelector(
		'.facets-container, [id*="Facets"]'
	);
	if (facetsContainer) {
		observer.observe(facetsContainer, { childList: true, subtree: true });
	}
}
